import { Container } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './CompanyIntro.css';

export interface CompanyIntroProps {
  introduction: AboutContentDto['introduction'];
  story: AboutContentDto['story'];
}

export function CompanyIntro({ introduction, story }: CompanyIntroProps) {
  return (
    <section className="dma-company-intro" aria-labelledby="dma-company-intro-heading">
      <Container>
        <h1 id="dma-company-intro-heading">درباره‌ی داریوش معدن آذر</h1>
        <p className="dma-company-intro__text">{introduction}</p>
        <p className="dma-company-intro__text">{story}</p>
      </Container>
    </section>
  );
}
